module.exports = __webpack_public_path__ + "assets/img/not_data_tips-dd687932.png";